import { render } from "./VehicleImplementsComponent.vue?vue&type=template&id=5c79376d&ts=true"
import script from "./VehicleImplementsComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleImplementsComponent.vue?vue&type=script&lang=ts"

import "./VehicleImplementsComponent.vue?vue&type=style&index=0&id=5c79376d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__